import { Dimension } from 'src/@enums'
import { gaEvent, getDimensionByUnit } from 'src/utils'

/**
 * Parâmetro para {@link newPaymentLink.success}
 */

export type NewPaymentLinkType = 'pix' | 'cartao-de-credito'

export type NewPaymentLinkEvent = {
  type: NewPaymentLinkType
  orderId: string
}

/**
 * Parâmetro para {@link newPaymentLink.error}
 */
export type NewPaymentLinkEventError = {
  type: NewPaymentLinkType
  orderId: string
  error?: string | number
}

const baseEvent = ({ type, orderId }: NewPaymentLinkEvent) => ({
  event: 'ga-event',
  'event-action': 'callback:cobranca',
  'event-category': `pagamentos-sellout:${type}`,
  [getDimensionByUnit(Dimension.TRANSACTION_ID)]: orderId,
})

/**
 * [TARGET]: Registrar evento de sucesso ou erro de um valor válido preenchido pelo usuário
 *
 * [CONTEXTO]: Na geração de cobrança, precisamos identificar se o usuário preencheu um valor válido ou inválido para entender o comportamento.
 *
 * [REGRAS]: n/a
 *
 */
export const newPaymentLink = {
  success: ({ type, orderId }: NewPaymentLinkEvent) => {
    const successEvent = {
      ...baseEvent({ type, orderId }),
      'event-label': 'sucesso',
    }
    gaEvent(successEvent)
  },

  error: ({ type, orderId, error = 'generic' }: NewPaymentLinkEventError) => {
    const errorEvent = {
      ...baseEvent({ type, orderId }),
      'event-label': `erro:${error}`,
    }
    gaEvent(errorEvent)
  },
}
